<template>
    <div class="earningsDoubleLineEchart border-radius5 white">
        <div class="module-header display-flex space-between">
            <div class="module-header-left title theme-font-color">
                {{$t('Yield_curve')}} {{currency}}
            </div>
          <!--不需要这个时间,展示所有的 todo-->
<!--            <div class="module-header-right">

                <el-select
                        size="small"
                    v-model="mounth"
                        style="width: 100px"
                >
                    <el-option
                        v-for="(item,index) in mounthOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </div>-->
        </div>
        <div class="content pr">
            <div class="statistics pa">
                <div class="statistics-left">
                    <span class="text">{{textComputed}}：</span>
                    <div class="left-data">
                        <div
                                class="recently"
                                :class="{
                                'theme-color': isIncludeMinus(statistics.recentlyProfit),
                                'theme-green': !isIncludeMinus(statistics.recentlyProfit),
                                }"
                        >{{statistics.recentlyProfit.replace('$','')}}</div>
                    </div>
                </div>
                <div class="statistics-right">
                    <span class="text">{{$t('yesterday')}}：</span>
                    <div class="left-data">
                        <div
                                class="recently"
                                :class="{
                                'theme-color': isIncludeMinus(statistics.todayProfit),
                                'theme-green': !isIncludeMinus(statistics.todayProfit),
                                }"
                        >{{statistics.todayProfit}}</div>
                    </div>
                </div>
            </div>
            <div class="chart-outer">
                <div class="no-data-outer center"
                     v-if="traderEarningsDataNullFlag"
                >
                    {{$t('root.noData')}}
                </div>
                <base-chart
                        ref="traderchart"
                        :chart-config="earningChartConfig"
                ></base-chart>
            </div>
        </div>
    </div>
</template>

<script>
    // mamSub mamMaster共用一个组件,改为了不共用
  import { queryCopyProfitInfo } from '@/api/copy'
  import { isIncludeMinus,setSufx } from '@/utils/common'
  let echarts = require('echarts');
  import baseChart from '@/components/echarts/baseChart';
  export default {
    name: 'earningsDoubleLineEchart',
    props: {
      rowData: {
        type: Object,
        default(){
          return {}
        }
      },
    },
    components:{
      baseChart
    },
    data() {
      let _this = this;
      return {
        statistics:{
          recentlyProfit: '',
          todayProfit: '0',
        },
        earningChartConfig: {
          tooltip: {
            trigger: 'axis',
            backgroundColor: "rgba(255,255,255,0.8)",
            borderColor: '#E6E6E6',
            borderWidth: 1,
            boxShadow: "0px 2px 12px 0px rgba(0, 0, 0, 0.06)",
            textStyle: {
              color: "#333333"
            },
            formatter:function(params,ticket,callback) {
              var res='<div><p>'+params[0].name+ '</p></div>';
              for(var i=0;i<params.length;i++){
                res+=`<p>${_this.$t('Today')}: ${params[i].data}</p>`
              }
              if(_this.profitAmount.length !== 0){
                res += `<p>${_this.$t('Grand_total')}: ${_this.profitAmount[params[0].dataIndex]}</p>`;
              }
              return res;
            },
          },
          grid: {
            show: false,
            top:'50px',
            left: '3%',
            right: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisTick: {
              show: false
            },
            axisLabel: {
              // formatter: '{value}%',
              color: '',
              fontSize: 14,
              margin: 20
            },
            axisLine: {
              lineStyle: {
                color: 'transparent'
              }
            },
          },
          yAxis: {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'transparent'
              }
            },
            //y轴设置为百分比
            axisLabel: {
              formatter: function (value) {
                return value;
              },
              color: '',
              fontSize: 14,
              margin: 20
            },
            //坐标轴内线的样式
            splitLine: {
              lineStyle: {
                color: 'rgba(233, 233, 233, 1)',
                type:'dashed'
              }
            }
          },
          series: [
            {
              name:'当日',
              type:'line',
              symbol: 'none',
              smooth: true,
              //  stack 会叠加
              // stack: 'vistors',
              data:[],
              itemStyle: {
                normal: {
                  color: '#11AB7F',
                  lineStyle: {
                    color: '#11AB7F',
                    width: 2
                  },
                },
              },
              /*区域颜色*/
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{        // 1代表上面
                  offset: 0,
                  color: 'rgba(134,203,190,0.5)'
                }, {
                  offset: 1,
                  color: 'rgba(187,231,224,0)'
                }]),
              }
            },
          ]
        },
        profitAmount: [],
        themeFontColor: '#333333'
      };
    },
    watch:{
      rowData:{
        handler(val){
          if(val.beginDate){
            let params = {
              beginDate: val.beginDate,
              endDate: val.endDate,
            }
            this.getData(params);
          }
        },
        deep: true,
      }
    },
    computed: {
      currency(){
         return 'USD';
      },
      traderEarningsDataNullFlag(){
        let flag = false;
        if(!this.earningChartConfig.series[0].data.length){
          flag = true;
        }
        return flag;
      },
      textComputed(){
        return this.$t('Nearly_a_month');
        /*switch (this.mounth) {
          case 1:

            break;
          case 2:
            return this.$t('Nearly_three_months');
            break;
          case 3:
            return this.$t('Nearly_a_year');
            break;
          case 4:
            return this.$t('All');
            break;
        }*/
      },
    },
    mounted(){
      if(!this.rowData.beginDate){
        return;
      }
      let params = {
        beginDate: this.rowData.beginDate,
        endDate: this.rowData.endDate,
      }
      this.getData(params);
    },
    methods: {
      isIncludeMinus,
      getData(params){
        queryCopyProfitInfo({
          mtId: this.$route.params.mtid,
          timeType: 2,
          beginDate: params.beginDate,
          endDate: params.endDate,
        }).then((res) => {
          this.earningChartConfig.xAxis.data = res.data.x;
          this.statistics.recentlyProfit = res.data.totalAmount;
          if(isIncludeMinus(this.statistics.recentlyProfit + '')) {
            this.earningChartConfig.series[0].itemStyle = {
              normal: {
                color: 'rgba(255, 127, 90, 1)',
                lineStyle: {
                  color: 'rgba(255, 127, 90, 1)',
                  width: 2
                },
              },
            };
            this.earningChartConfig.series[0].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{        // 1代表上面
                offset: 0,
                color: 'rgba(255, 127, 90, 0.2)'
              }, {
                offset: 1,
                color: 'rgba(255, 127, 90, 0)'
              }]),
            };
          }
          let handleProfitDay = [];
          let handleProfitAmount = [];

          if(res.data.y.length){
            for (let i = 0; i < res.data.y.length; i++) {
              handleProfitDay.push(res.data.y[i].profitDay);
              handleProfitAmount.push(res.data.y[i].profitAmount);
            }
            this.statistics.todayProfit = res.data.y[res.data.y.length - 1].profitDay;
          }
          this.earningChartConfig.series[0].data = handleProfitDay;
          this.profitAmount = handleProfitAmount;

          this.earningChartConfig.xAxis.axisLabel.color = this.themeFontColor;
          this.earningChartConfig.yAxis.axisLabel.color = this.themeFontColor;
          this.$refs.traderchart && this.$refs.traderchart.set();
        })
      },
    }
  };
</script>

<style lang="scss" scoped>
.earningsDoubleLineEchart {
    .module-header {
        .title {
            font-size: 16px;
            font-weight: bold;
        }
    }
    .content {
        padding-top: 20px;
        .statistics {
            left: 20px;
            top: 20px;
            .recently {
                font-size: 12px;
            }
        }
        .statistics,
        .statistics-left,
        .statistics-right {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .statistics-left {
            margin-right: 30px;
        }
        .first {
            margin-bottom: 10px;
        }
    }
    .chart-outer {
        height: 420px;
    }
    .no-data-outer {
        line-height: 420px;
    }
}
</style>
